import type { ConditionBuildableId } from "@skilitics/nautilus-core-designer-data";

import type { GetDesignerNodeById } from "../../state/selectors/getDesignerNodeById.ts";
import type { ConditionBuildable } from "../../types/index.ts";
import type { GetNodeConditionBuildables } from "../querying/index.ts";

const isMatchCreate = (id: ConditionBuildableId) => (b: ConditionBuildable) =>
  b.nodeId === id.nodeId && b.name === id.name;

export const getConditionBuildableCreate =
  (
    getNodeConditionBuildables: GetNodeConditionBuildables,
    getById: GetDesignerNodeById,
    utilityBuildables?: ReadonlyArray<ConditionBuildable>,
  ) =>
  (id: ConditionBuildableId): ConditionBuildable | undefined => {
    const isMatch = isMatchCreate(id);
    const buildable = id.nodeId
      ? getNodeConditionBuildables(getById(id.nodeId), { includeChildren: true }).find(isMatch)
      : undefined;
    // TODO: get environment value buildable
    if (!buildable && utilityBuildables) {
      return utilityBuildables.map((b) => ({ ...b, nodeId: id.nodeId })).find(isMatch);
    }
    return buildable;
  };

export type GetConditionBuildable = ReturnType<typeof getConditionBuildableCreate>;
